import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { IMAGES } from '../data/content';
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-12 pt-10 sm:px-8 sm:pb-16 sm:pt-14" data-id="element-105" data-mp="9ka68zwg6uxg">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-3xl text-center" data-id="element-106" data-mp="4lyxkshw2qgt">
        <h1 className="font-display text-3xl font-black uppercase leading-[1.08] tracking-tight text-plum sm:text-5xl" data-id="element-107" data-mp="xa4ibf8y0fgn">
          Terminá lo que empezás en solo{' '}
          <span className="text-terracotta" data-id="element-108" data-mp="nc86smc3fii0">8 minutos al día</span>
        </h1>
        <p className="mx-auto mt-4 max-w-2xl font-sans text-base leading-relaxed text-plum-soft sm:text-lg" data-id="element-109" data-mp="neaugzprwzjk">
          El método de <strong className="font-bold text-plum" data-id="element-110" data-mp="382fhvvzgliim">arte + EFT (tapping)</strong> que ya
          usaron <strong className="font-bold text-plum" data-id="element-111" data-mp="3j8ixl0k6uiv8">+10.000 mujeres</strong> para dejar de
          procrastinar, sin depender de la fuerza de voluntad.
        </p>
        <div className="mx-auto mt-8 max-w-xl overflow-hidden rounded-2xl border-4 border-cream-deep shadow-xl" data-id="element-112" data-mp="3o73og9djvq70">
          <video src={IMAGES.heroVideo} className="h-full w-full object-cover" autoPlay loop muted playsInline data-id="element-113" data-mp="39cflb1vmh3uk" />
        </div>
        <div className="mt-8 flex justify-center" data-id="element-114" data-mp="30fybq32wpe0x">
          <CTAButton size="lg" data-id="element-115" data-mp="359t0hkxdcj6v">Quiero mi guía</CTAButton>
        </div>
        <p className="mt-4 font-sans text-xs font-semibold uppercase tracking-[0.12em] text-plum-soft" data-id="element-116" data-mp="2qk3k4igpg8m0">
          Acceso inmediato · Pago único · Garantía 7 días
        </p>
        <div className="mt-3 flex items-center justify-center gap-2" data-id="element-117" data-mp="2vgtx2wx7qo37">
          <div className="flex" aria-hidden="true" data-id="element-118" data-mp="2hjoy1gvx2phg">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-119" data-mp="2ljh0rcymq1ew" />)}
          </div>
          <span className="font-sans text-xs font-semibold text-plum-soft" data-id="element-120" data-mp="s3md82jz5yyd">
            4.9/5 · +10.000 mujeres
          </span>
        </div>
      </motion.div>
    </section>;
}